module.exports = __webpack_public_path__ + "img/dry-hairy-tree-08.5c5da95f.png";